import script from "./prizeDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./prizeDialog.vue?vue&type=script&lang=ts&setup=true"

import "./prizeDialog.vue?vue&type=style&index=0&id=5b11c4e2&lang=scss&scoped=true"

import exportComponent from "/home/deploy/www/data/workspace/ads_tencn-prod/ads/src/grow-team-assist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b11c4e2"]])

export default __exports__